import { useMemo } from 'react'
import { useTranslation } from 'src/utils/i18n'
import StepLayout from './StepLayout'

const Contacts = () => {
  const { t } = useTranslation('commonAndroid')
  const step = useMemo(
    () => [
      {
        title: <span>{t('Open Settings and click Google')}.</span>,
        img: [
          {
            src: '/images/login/backup6.png'
          }
        ]
      },
      {
        title: <span>{t('Click Settings for Google apps')}.</span>,
        img: [
          {
            src: '/images/login/backup7.png'
          }
        ]
      },
      {
        title: <span>{t('Click Google Contacts sync')}.</span>,
        img: [
          {
            src: '/images/login/backup8.png'
          }
        ]
      },
      {
        title: <span>{t('Click Also sync device contacts')}.</span>,
        img: [
          {
            src: '/images/login/backup9.png'
          }
        ]
      },
      {
        title: (
          <span>{t('Choose the backup account and turn on the Automatically back up  sync device contacts')}.</span>
        ),
        img: [
          {
            src: '/images/login/backup10.png'
          }
        ]
      }
    ],
    [t]
  )

  return <StepLayout title={t('Back up contacts')} step={step} />
}

export default Contacts
